import type React from "react";

interface NumberInputWheelEvent extends React.WheelEvent<HTMLInputElement> {
  target: HTMLInputElement;
}

export const numberInputOnWheelPreventChange = (
  e: NumberInputWheelEvent,
): void => {
  e.target.blur();
  setTimeout(() => {
    e.target.focus();
  }, 0);
};
